export default __webpack_public_path__ + "static/media/ethereum_background.1e0b7ae2.jpg";